import { ChatMessage, TEMP_USER_MESSAGE_PREFIX } from "@store/messages.store";
import { FileType } from "@shared/utils/mimetype";

export const formatMessage = (
  message: string,
  { fileUrl, fileType }: { fileUrl: string | null; fileType: FileType | null }
) => {
  if (!fileUrl) {
    return message;
  }

  if (fileType === "image") {
    return `${message}\n\n![image](${fileUrl})`;
  }

  return `${message}\n\n${fileUrl}`;
};

export const getNewTempUserMessage = (params: {
  text: string;
  type?: "text" | "file";
  user: any;
}): ChatMessage => {
  const { text, type = "text", user } = params;

  return {
    id: `${TEMP_USER_MESSAGE_PREFIX}${Math.random().toString(32).slice(2)}`,
    text,
    createdAt: new Date(),
    type,
    user: {
      name: user?.name || "User",
      avatar: user?.avatar || "",
    },
    createdBy: "user",
  };
};
